import {
  Appointment,
  APPOINTMENT_STATUS,
  QUEUE_CARD_ACTIONS,
} from "@elixir/types";
import ShowSelectedTags from "../../button/queue/columns/show-selected-tags";
import VisitType from "../../button/queue/columns/visit-type";
import PaymentStatus from "../../button/queue/columns/payment-status";
import SaStatusWrapper from "../../button/queue/columns/sa-status-wrapper";
import PastVisit from "../../button/queue/columns/past-visit";
import AbhaId from "../../button/queue/columns/abha-id";
import AddVitalsAndLabResults from "../../button/queue/actions/add-vitals-and-lab-results";
import AddAddress from "../../button/queue/actions/add-address";
import RequestMedicalRecords from "../../button/queue/actions/request-medical-records";
import RequestPayment from "../../button/queue/actions/request-payment";
import ArchiveAppointment from "../../button/queue/actions/archive-appoinment";
import ReferToDoctor from "../../button/queue/actions/refer-to-doctor";
import SendGoogleReviewLinkButton from "../../button/queue/actions/send-google-review-link-button";
import MarkNoShow from "../../button/queue/actions/mark-no-show";
import UploadMedicalRecord from "../../button/queue/actions/upload-medical-record";
import CreateATemplate from "../../button/queue/actions/create-a-template";
import FollowUp from "../../button/queue/actions/follow-up";
import CreateMedicalCertificate from "../../button/queue/actions/create-medical-certifcate";
import ReceiptButton from "../../button/queue/actions/receipt-button";
import CheckInButton from "../../button/queue/actions/check-in-button";
import OrderMedicineButton from "../../button/queue/actions/order-medicine-button";
import PrintRxButton from "../../button/queue/actions/print-rx-button";
import WriteRxButton from "../../button/queue/actions/write-rx-button";
import CheckOutButton from "../../button/queue/actions/check-out-button";
import OpenQuestionnaire from "../../button/queue/actions/open-questionnaire";
import AptFieldAction from "../../button/queue/apt-fields/apt-field-action";
import LabelsDropdown from "../../button/queue/columns/labels-dropdown";
import Notes from "../../button/queue/actions/notes";
import AssignDoctor from "../../button/queue/actions/assign-doctor";
import RescheduleAppointment from "../../button/queue/actions/reschedule-appt";
import AddServicesToAppointment from "../../button/queue/columns/add-services-to-appointment";

const QueueCardAction = ({
  appointment,
  queueType,
  columnId,
  className = "dr-flex-1 dr-max-w-165",
  type,
}: {
  appointment: Appointment;
  type?: "primary" | "secondary";
  columnId: string;
  queueType: string;
  className?: string;
}) => {
  switch (columnId) {
    case QUEUE_CARD_ACTIONS.TAGS:
      return (
        <ShowSelectedTags
          queueType={queueType}
          apt={appointment}
          className={"dr-flex-1 dr-max-w-330"}
        />
      );
    case QUEUE_CARD_ACTIONS.VISIT_TYPE:
      return (
        <VisitType apt={appointment} className={"dr-max-w-165 dr-w-max"} />
      );
    case QUEUE_CARD_ACTIONS.PAYMENT_STATUS:
      return <PaymentStatus apt={appointment} className={className} />;
    case QUEUE_CARD_ACTIONS.ASSESSMENT_STATUS:
      return <SaStatusWrapper apt={appointment} className={className} />;
    case QUEUE_CARD_ACTIONS.PAST_VISITS:
      return <PastVisit apt={appointment} className={className} />;
    case QUEUE_CARD_ACTIONS.ABHA_ID:
      return <AbhaId apt={appointment} className={className} />;
    case QUEUE_CARD_ACTIONS.ADD_VITALS_AND_LAB_RESULTS:
      return (
        <AddVitalsAndLabResults
          apt={appointment}
          className={className}
          type={type}
        />
      );
    case QUEUE_CARD_ACTIONS.ADD_ADDRESS:
      return <AddAddress apt={appointment} className={className} type={type} />;
    case QUEUE_CARD_ACTIONS.REQUEST_RECORDS:
      return (
        <RequestMedicalRecords
          apt={appointment}
          className={className}
          type={type}
        />
      );
    case QUEUE_CARD_ACTIONS.REQUEST_PAYMENT:
      return (
        <RequestPayment apt={appointment} className={className} type={type} />
      );
    case QUEUE_CARD_ACTIONS.ARCHIVE_APPOINTMENT:
      return (
        <ArchiveAppointment
          apt={appointment}
          className={className}
          type={type}
        />
      );
    case QUEUE_CARD_ACTIONS.CREATE_CERTIFICATE:
      return (
        <CreateMedicalCertificate
          apt={appointment}
          className={className}
          type={type}
        />
      );
    case QUEUE_CARD_ACTIONS.REFER_TO_DOCTOR:
      return (
        <ReferToDoctor apt={appointment} className={className} type={type} />
      );
    case QUEUE_CARD_ACTIONS.SEND_GOOGLE_REVIEW_LINK:
      return (
        <SendGoogleReviewLinkButton
          apt={appointment}
          className={className}
          type={type}
        />
      );
    case QUEUE_CARD_ACTIONS.MARK_NO_SHOW:
      return <MarkNoShow apt={appointment} className={className} type={type} />;
    case QUEUE_CARD_ACTIONS.UPLOAD_MEDICAL_RECORDS:
      return (
        <UploadMedicalRecord
          apt={appointment}
          className={className}
          type={type}
        />
      );
    case QUEUE_CARD_ACTIONS.CREATE_TEMPLATE:
      return (
        <CreateATemplate apt={appointment} className={className} type={type} />
      );
    case QUEUE_CARD_ACTIONS.FOLLOW_UP:
      return <FollowUp apt={appointment} className={className} type={type} />;
    case QUEUE_CARD_ACTIONS.CREATE_ABHA:
      return <AbhaId apt={appointment} className={className} />;
    case QUEUE_CARD_ACTIONS.RECEIPT:
      return <ReceiptButton apt={appointment} className={className} />;
    case QUEUE_CARD_ACTIONS.CHECK_IN:
      return (
        <CheckInButton apt={appointment} className={className} type={type} />
      );
    case QUEUE_CARD_ACTIONS.ORDER_MEDICINE:
      return (
        <OrderMedicineButton
          apt={appointment}
          className={className}
          type={type}
        />
      );
    case QUEUE_CARD_ACTIONS.PRINT_RX:
      return (
        <PrintRxButton apt={appointment} className={className} type={type} />
      );
    case QUEUE_CARD_ACTIONS.WRITE_RX:
      return (
        <WriteRxButton apt={appointment} className={className} type={type} />
      );
    case QUEUE_CARD_ACTIONS.EXIT:
      return (
        <CheckOutButton apt={appointment} className={className} type={type} />
      );
    case QUEUE_CARD_ACTIONS.QUESTIONAIRE:
      return <OpenQuestionnaire />;
    case QUEUE_CARD_ACTIONS.LABEL:
      return <LabelsDropdown apt={appointment} />;
    case QUEUE_CARD_ACTIONS.NOTES: {
      const allowedStatuses = [
        APPOINTMENT_STATUS.BOOKED,
        APPOINTMENT_STATUS.CHECKED_IN,
        APPOINTMENT_STATUS.ONGOING,
      ];
      const isAllowed = allowedStatuses.includes(appointment.status);
      if (!isAllowed) return null;
      return <Notes apt={appointment} className={className} type={type} />;
    }
    case QUEUE_CARD_ACTIONS.ASSIGN_DOCTOR: {
      const allowedStatuses = [APPOINTMENT_STATUS.BOOKED];
      const isAllowed = allowedStatuses.includes(appointment.status);
      if (!isAllowed) return null;
      return (
        <AssignDoctor apt={appointment} className={className} type={type} />
      );
    }
    case QUEUE_CARD_ACTIONS.RESCHEDULE_APPOINTMENT: {
      const allowedStatuses = [APPOINTMENT_STATUS.BOOKED];
      const isAllowed = allowedStatuses.includes(appointment.status);
      if (!isAllowed) return null;
      return (
        <RescheduleAppointment
          apt={appointment}
          className={className}
          type={type}
        />
      );
    }
    case QUEUE_CARD_ACTIONS.ADD_SERVICES_TO_APPOINTMENT:
      return (
        <AddServicesToAppointment
          apt={appointment}
          numberOfChipsToShow={2}
          className={"dr-max-w-330"}
        />
      );
    default:
      return <AptFieldAction apt={appointment} fieldId={columnId} />;
  }
};

export default QueueCardAction;
